$('.reviews-slider').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.video-slider').slick({
  dots: false,
  infinite: true,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }
  ]
});

$('.unlock_images').slick({
  dots: false,
  infinite: true,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

// Get the faqs
var faqBtn = document.querySelectorAll('[data-faq]');

// When the user clicks the button, open the modal 
for (let i = 0; i < faqBtn.length; i++) {
  faqBtn[i].onclick = function() {
  var targetFaq = faqBtn[i].getAttribute('target-faq');
  var faq = document.getElementById(targetFaq);
  faq.classList.toggle("hide");
}
}


// Get the modal
var modals = document.querySelectorAll('.modal')
  
var modalClose = document.querySelectorAll('.modal .close')
var modalBoxClose = document.querySelectorAll('.modal .close-box')

// Get the button that opens the modal
var modalBtn = document.querySelectorAll('[data-modal]');
var modalBoxBtn = document.querySelectorAll('[data-box-modal]');

// When the user clicks the button, open the modal 
for (let i = 0; i < modalBtn.length; i++) {
  modalBtn[i].onclick = function() {
  var targetModal = modalBtn[i].getAttribute('target-modal');
  var modal = document.getElementById(targetModal);
  modal.style.display = "block";
  document.body.classList.add('modal-open');
	  
  var targetDataSource = modalBtn[i].getAttribute('data-source');
  var targetDataVideo = modalBtn[i].getAttribute('data-video');
  
  if (targetDataSource === 'youtube') {
	if (document.querySelector('script[src="https://www.youtube.com/player_api"]') === null) {
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	//var data_video = param.getAttribute('data-video');
	var player;
	function onYouTubePlayerAPIReady(id) {
		player = new YT.Player(id, {
			videoId: id.split('-')[0],
			playerVars: {
				'autoplay': 1,
				'showinfo': 0
			}
		});
	}
	document.querySelector('.video-holder').setAttribute('id',targetDataVideo)
	setTimeout(function() {
		onYouTubePlayerAPIReady(targetDataVideo);
	}, 1000)
  } else if (targetDataSource === 'shopify') {
	  	var hostedVideo = document.createElement('video');
		hostedVideo.src = targetDataVideo;
	  	hostedVideo.setAttribute("controls", "controls");
	    document.querySelector('.video-holder').appendChild(hostedVideo);
		hostedVideo.autoplay = true;
  }
}
}

function setupModalBox() {
  if (window.innerWidth > 767) {
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = function() {
        var targetModal = modalBoxBtn[i].getAttribute('target-modal');
        var modal = document.getElementById(targetModal);
        modal.style.display = "block";
        document.body.classList.add('modal-open');

        var targetDataImage = modalBoxBtn[i].getAttribute('data-image');

        var hostedImage = document.createElement('img');
        hostedImage.src = targetDataImage;
        document.querySelector('.box-holder').appendChild(hostedImage);
      }
    }
  } else {
    // If the screen is smaller than 767px, you might want to remove any existing click event handlers
    // and hide any displayed modals.
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = null;
    }
  }
}

// Call the setup function when the page loads
window.addEventListener('load', setupModalBox);

// Call the setup function when the window is resized
window.addEventListener('resize', setupModalBox);

// When the user clicks on <span> (x), close the modal  
for (let i = 0; i < modalClose.length; i++) {
modalClose[i].onclick = function() {
  var closeTargetModal = modalClose[i].getAttribute('target-modal');
  var closeModal = document.getElementById(closeTargetModal);
  closeModal.style.display = "none";
  document.body.classList.remove('modal-open');
  document.querySelector('.video-holder').remove();
  var videoHolder = document.createElement("div");
  videoHolder.classList.add('video-holder') 
  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);
}
} 

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  for (let i = 0; i < modals.length; i++) {
    if ( (event.target == modals[i]) || (event.target.className == "modal-content") ) {
      modals[i].style.display = "none";
      
      document.body.classList.remove('modal-open');
	  document.querySelector('.video-holder').remove();
	  var videoHolder = document.createElement("div");
	  videoHolder.classList.add('video-holder') 
	  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);

    }
  }
}